import { PathQueryKey } from "./page/pageProp";

// The Default Devcontainer: its own Noun (query-omega-oql oql/app/default-devcontainer.oql), path system:#devcontainer. The frontend reaches it
// ONLY through the generic public wrapper Qo.Public.Api/path-query, as the Home Record does (types/home.ts).
export const DefaultDevcontainerKey = "omega/query-omega/default-devcontainer/DefaultDevcontainer" as const;

// {"type" DefaultDevcontainer "account-id" Acct "devcontainer-id" DcId "stored" Stored}; "devcontainer-id" is "" when the account has none
// (default-devcontainer.oql lines 9-17).
export interface DefaultDevcontainerRecord {
  type: typeof DefaultDevcontainerKey;
  "account-id": string;
  "devcontainer-id": string;
  stored: boolean;
}

// record-type "devcontainer" is the key Qo.Pq.DefaultDevcontainer registers under (oql/app/path/path-query/default-devcontainer.oql); with no
// "record-name" it resolves to the caller.
export const defaultDevcontainerPathQuery = { type: PathQueryKey, "record-type": "devcontainer" } as const;

// The Default Devcontainer's id, or undefined when the Record names none ("").
export const defaultDevcontainerIdOf = (record: DefaultDevcontainerRecord | undefined): string | undefined =>
  record?.["devcontainer-id"] || undefined;
